import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../lib/pixel';
export function Offer() {
  return <section id="offer" className="py-24 px-6 bg-[#111113] relative overflow-hidden" data-id="element-230">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-96 bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-231" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-232">
        <FadeIn data-id="element-233">
          <div className="bg-zinc-950 border border-amber-500/30 rounded-3xl p-8 sm:p-12 text-center shadow-[0_0_50px_rgba(245,158,11,0.05)]" data-id="element-234">
            <h2 className="text-2xl sm:text-3xl font-medium text-white mb-4 leading-snug" data-id="element-235">
              El Protocolo Completo + Los 3 Bonos
            </h2>

            <p className="text-zinc-400 mb-8" data-id="element-236">
              Todo el ecosistema del Protocolo Dopamina Cero por una única
              inversión.
            </p>

            <div className="mb-6" data-id="element-237">
              <span className="block text-zinc-500 text-sm mb-1" data-id="element-238">
                Valor total del stack
              </span>
              <span className="text-2xl text-zinc-500 line-through font-semibold" data-id="element-239">
                $238 USD
              </span>
            </div>

            <div className="mb-10" data-id="element-240">
              <span className="block text-amber-500 font-bold uppercase tracking-widest text-sm mb-2" data-id="element-241">
                Tu Inversión Hoy
              </span>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-242">
                <span className="text-2xl text-zinc-500 line-through font-semibold" data-id="element-243">
                  $17 USD
                </span>
                <span className="bg-red-500/20 text-red-400 text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-244">
                  -63% OFF
                </span>
              </div>
              <div className="flex items-start justify-center gap-1" data-id="element-245">
                <span className="text-3xl font-bold text-white mt-2" data-id="element-246">$</span>
                <span className="font-bebas text-8xl text-white leading-none" data-id="element-247">
                  6.36
                </span>
                <span className="text-xl font-bold text-zinc-500 mt-auto mb-2" data-id="element-248">
                  USD
                </span>
              </div>
              <p className="text-zinc-500 text-sm mt-2" data-id="element-249">
                Una sola vez. Sin suscripción. Sin pagos futuros.
              </p>
            </div>

            <motion.a href="https://renacelibre.com/cart/42860714426445:1" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-amber-500 text-zinc-950 font-bold text-lg sm:text-xl py-5 rounded-xl uppercase tracking-wide shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] transition-shadow mb-6" data-id="element-250">
              Quiero El Protocolo + Los 3 Bonos Gratis
            </motion.a>

            {/* Guarantee */}
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-4 mb-6 flex items-start gap-3 text-left" data-id="element-251">
              <ZapIcon className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-252" />
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-253">
                <strong className="text-zinc-300" data-id="element-254">Garantía de 7 días:</strong>{' '}
                Si no ves ningún cambio, te devolvemos el dinero sin preguntas.
                El único riesgo real es quedarte donde estás.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-zinc-400" data-id="element-255">
              <div className="flex items-center gap-2" data-id="element-256">
                <LockIcon className="w-4 h-4 text-zinc-500" data-id="element-257" />
                <span data-id="element-258">Pago 100% Seguro</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-zinc-700 rounded-full" data-id="element-259" />
              <div className="flex items-center gap-2" data-id="element-260">
                <ShieldCheckIcon className="w-4 h-4 text-zinc-500" data-id="element-261" />
                <span data-id="element-262">Acceso Inmediato · Descarga Directa</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}